export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Communication Group Name',
        sort: true,
        headerStyle: () => { return { width: '250px', ...headerStyle() }; },
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true,
        headerStyle: () => { return { minWidth: '200px', ...headerStyle() }; },
        style: columnStyle
    },
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];